var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralActionCheckboxOff = function SvgGeneralActionCheckboxOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 20.459A1.46 1.46 0 0 1 3.542 19V5A1.46 1.46 0 0 1 5 3.542h14a1.46 1.46 0 0 1 1.458 1.459v14A1.46 1.46 0 0 1 19 20.459z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M19 2.667H5a2.333 2.333 0 0 0-2.333 2.334v14A2.333 2.333 0 0 0 5 21.334h14A2.334 2.334 0 0 0 21.335 19V5A2.333 2.333 0 0 0 19 2.667m0 1.75c.321 0 .584.262.584.584v14c0 .32-.263.583-.584.583H5A.584.584 0 0 1 4.417 19V5c0-.322.261-.584.583-.584z"
  }))));
};
export default SvgGeneralActionCheckboxOff;